import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@common/components/icon';
import { ToggleInput } from '@common/components/form/inputs/toggle';
import { TextInput, Row, Group } from '@common/components/form';

type Props = {
  enableDescription?: boolean;
};

export const BooleanQuestionInput = ({ enableDescription }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Group>
          <TextInput name="parameters.text" placeholder={t('survey:question_form_question_placeholder')} />
        </Group>
      </Row>
      {enableDescription && (
        <Row>
          <Group>
            <TextInput
              name="parameters.description"
              placeholder={t('survey:question_form_description_placeholder')}
              maxLength={160}
            />
          </Group>
        </Row>
      )}
    </>
  );
};

export const BooleanQuestionSettings = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="QuestionForm__ValueLabel">
        <span>{t('survey:question_type_values_label')}</span>
        <Icon type="help__filled" />
      </div>

      <div className="BooleanQuestionSettings__LabelInputs">
        <TextInput name="parameters.label_true" maxLength={12} />
        <TextInput name="parameters.label_false" maxLength={12} />
      </div>

      <Row>
        <Group>
          <ToggleInput
            reversed
            helpIcon
            name="parameters.answer_required"
            label={t('survey:question_form_answer_is_required')}
          />
        </Group>
      </Row>
    </>
  );
};
